<template>
  <div class="wrapper">
    <div class="main visual-2 verify-appont">
      <Header backRoute="/appointments" />
      <div class="vis4-inr1">
        <h1>Verify Your Appointment</h1>
        <!-- <h4>Choose an option:</h4> -->
        <div class="verify-btn">
          <!-- <router-link to="">
            <button>Phone Number</button>
          </router-link>
          <router-link to="">
            <button>Email</button>
          </router-link> -->
          <router-link to="/enter-appointment-id">
            <button>Appointment ID</button>
          </router-link>
        </div>
      </div>
      <FooterView :showButtons="true" />
    </div>
  </div>
</template>

<script>
import FooterView from "@/layout/Footer.vue";
import Header from "@/layout/Header.vue";
export default {
  components: {
    FooterView,
    Header,
  },
  name: "VerifyAppointment",
};
</script>
